import { useQuery } from '@apollo/react-hooks';

import { getLearningResultReport } from 'GraphQL/queries/report.query';

const LearningResultReportData = ({ value, schoolCode, children }) => {
  const { term, grade, classNo, subject, syllabus, lesson } = value;

  const variables = {
    schoolTermId: term,
    schoolGradeId: grade !== `all-grade-selected` ? grade : null,
    classNo: classNo !== `all-class-selected` ? classNo : null,
    subjectId: subject,
    courseCode: syllabus !== `all-syllabus-selected` ? syllabus : null,
    lessonId: lesson && lesson !== `all-lesson-selected` ? lesson : null,
    schoolCode,
  };

  const isSkip = !term || !grade || !classNo || !subject || !schoolCode;

  const report = useQuery(getLearningResultReport, {
    variables: variables,
    skip: isSkip,
    notifyOnNetworkStatusChange: true,
  });

  const { loading, error, data, refetch, networkStatus } = report;
  return children({ loading, error, data, refetch, networkStatus });
};

export default LearningResultReportData;
